import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

type MessageType = 'text' | 'image' | 'label';

@Injectable({
  providedIn: 'root',
})
export class ServerService {
  appendClientMessage$ = new Subject();
  appendServerMessage$ = new Subject<{
    type: MessageType;
    thread: any;
  }>();

  appendServerLocalMessage$ = new Subject<{
    msgId: any;
    type: MessageType;
    content: string;
  }>();
  updateServerLocalMessage$ = new Subject<{
    msgId: any;
    data: any;
  }>();

  checkStatus$ = new Subject<boolean>();
  activatedThread$ = new Subject<{ operator_id: number; [prop: string]: any }>();
  // updateThread$ = new Subject<any>();
  updateThread$ = new Subject<{ operator_id: string; thread: any }>();
  selectQuickMessage$ = new Subject<string>();
  customerStatus$ = new Subject<boolean>();

  updateClientEntry$ = new Subject<string>();
  refreshThreadList$ = new Subject();
  constructor() {}

  activateThread(thread) {
    this.activatedThread$.next(thread);
  }

  updateCheckStatus(status: boolean) {
    this.checkStatus$.next(status);
  }

  selectQuickMessage(value: string) {
    this.selectQuickMessage$.next(value);
  }

  updateThread(options: { operator_id: string; thread: any }) {
    this.updateThread$.next(options);
  }

  appendClientMessage(type: MessageType, content: string) {
    this.appendClientMessage$.next({ type, content });
  }

  appendServerMessage(type: MessageType, thread: any) {
    this.appendServerMessage$.next({ type, thread });
  }

  appendServerLocalMessage(msgId, type: MessageType, content: string) {
    this.appendServerLocalMessage$.next({ msgId, type, content });
  }

  updateServerLocalMessage(msgId, data) {
    this.updateServerLocalMessage$.next({ msgId, data });
  }

  updateClientEntry(entry) {
    this.updateClientEntry$.next(entry);
  }

  refreshThreadList() {
    this.refreshThreadList$.next(null);
  }
}
